import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SlickDirective } from 'src/app/core/directives/slick.directive';
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params } from 'src/environments/environment';

@Component({
  selector: 'app-slide-people',
  templateUrl: './slide-people.component.html',
  styleUrls: ['./slide-people.component.scss']
})
export class SlidePeopleComponent implements OnInit {
  @ViewChild(SlickDirective) slickDirective: SlickDirective;
  slickOptions: any = {
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnDotsHover: true,
    arrows: false,
    dots: true,
    infinite: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  };
  urlBaseS3: any = (<any>params).api.s3;
  public errors: any = null;
  public loadings: any = true;
  public generalOpt: any;
  @Input() public route: string;
  @Input() public load_serv: boolean = true;
  @Input('data') public comments: any = null;
  prevLimit: any = true;
  nextLimit: any = false;

  dotFace = 'assets/img/avatar-t.svg';
  constructor(
    private _homeService: HomeService,
  ) {

  }

  ngOnInit() {
    if (this.load_serv) {
      this.getComments();
    }
  }

  /**
   * slide siguiente
   */
  next() {
    this.slickDirective.next();
  }

  /**
   * slide anterior
   */
  prev() {
    this.slickDirective.prev();
  }

  getComments() {
    this._homeService.getComments(this.route).subscribe(data => {
      this.comments = data.testimonios;
      console.log('Testiiiiiiimonios: ', data);
      if (!(data.testimonios && data.testimonios.content_post && data.testimonios.content_post.length > 0)) {
        console.warn('Sin testimonios para mostrar');
        this.loadings = false;
      }
    }, err => {
      console.error(err);
      this.errors = err;
    });
  }

  reload() {
    this.loadings = true;
    this.getComments();
  }

  changeSlick(event){
    this.prevLimit = event.nextSlide==0? true : false;
    this.nextLimit = event.nextSlide==Math.ceil(this.comments.content_post.length/2)? true : false;
  }
}
